import { useState } from 'react';
import classNames from 'classnames';

import emptyImageIconUrl from './assets/empty-image.svg';

interface Props {
    image?: string;
    altText: string;
    frame?: boolean;
    role?: string;
    onClick?: (event?: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
}

export const Image = ({ image, altText, frame = true, role, onClick = () => undefined, ...otherProps }: Props) => {
    const [imageUrl, setImageUrl] = useState(image);
    const removeImage = () => {
        setImageUrl(undefined);
    };
    if (imageUrl) {
        // biome-ignore lint/a11y/useAltText: This is a false positive, altText is provided
        return (
            <img
                role={role}
                src={imageUrl}
                className={classNames('center-cropped', { 'image-frame': frame, clickable: !!onClick })}
                alt={altText}
                onError={removeImage}
                onClick={onClick}
                {...otherProps}
            />
        );
    }

    // biome-ignore lint/a11y/useAltText: This is a false positive, altText is provided
    return (
        <img
            src={emptyImageIconUrl.src}
            className={classNames('u-bg-ice center-cropped placeholder-image', { 'image-frame': frame, clickable: Boolean(onClick) })}
            alt={altText}
            {...otherProps}
        />
    );
};
